import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { RealEstateResearchRequestWizard } from "./components/RealEstateResearchRequestWizard";

export const RealEstateResearchRequestPage: React.FC = () => {
  const navigate = useNavigate();

  const handleClose = (): void => {
    navigate("/mypage");
  };

  return (
    <Box sx={{ backgroundColor: "background.default", minHeight: "100%" }}>
      <RealEstateResearchRequestWizard open onClose={handleClose} />
    </Box>
  );
};
